















import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import HeaderMixins from './mixins';
import { mapState, mapGetters } from 'vuex';

import('@/assets/header/' + process.env.VUE_APP_CLIENT + '/' + process.env.VUE_APP_THEME + '/style.scss').catch((e) => {
  import('@/assets/header/' + process.env.VUE_APP_CLIENT + '/style.scss');
});

@Component({
  computed: {
    ...mapState({
      HeaderTitle: 'Header',
    }),
  },
})
export default class Header extends mixins(Vue, HeaderMixins) {
  public showTitle: boolean = true;

  public HeaderTitle!: string;

  mounted() {
    if (process.env.VUE_APP_CLIENT === 'test') {
      this.showTitle = false;
    }
  }

  get title() {
    if (this.$route.name == 'Login') {
      if (process.env.VUE_APP_CLIENT === 'vaadrehuvot') {
        return 'בחירות לוועד העובדים בעיריית רחובות';
      }
      if (process.env.VUE_APP_CLIENT === 'akum') {
        return 'אסיפה כללית שנתית  ומיוחדת 28.7.24';
      }
      if (process.env.VUE_APP_CLIENT === 'vaizman') {
        return 'בחירות 2024 לראשות ולחברי ועד העובדים';
      }
      if (process.env.VUE_APP_CLIENT === 'veidaya') {
        return 'ועידת יש עתיד 2024 בחירות לתפקיד יו"ר המפלגה';
      }
      if (process.env.VUE_APP_CLIENT === 'reichman') {
        return 'בחירות לתפקידי ראשות האגודה ונציגי מסלול אוניברסיטת רייכמן';
      }
      if (process.env.VUE_APP_CLIENT === 'iai') {
        return '';
      }
      if (process.env.VUE_APP_CLIENT === 'elalkupa') {
        return 'קופת התגמולים עובדי אלעל';
      }
      if (process.env.VUE_APP_CLIENT === 'migzar3') {
        return 'בחירות לועד המנהל של מנהיגות אזרחית 2025';
      }
    }

    return (this.showTitle && this.HeaderTitle) || '';
  }
}
